import React from 'react';

const API = `${(process.env.REACT_APP_BACKEND_URL || 'https://bobine.live')}/api`;

const EclaireurModal = ({
  eclaireurStep, eclaireurSelectedIds, setEclaireurSelectedIds,
  eclaireurMessage, setEclaireurMessage, eclaireurLink,
  eclaireurLoading, eclaireurLinkCopied,
  photos, token, generateEclaireurLink, toggleEclaireurPhoto,
  copyEclaireurLink, shareOnWhatsApp, onClose, t,
  eclaireurEmail, setEclaireurEmail, eclaireurEmailSending, eclaireurEmailSent, eclaireurEmailError, sendEclaireurEmail,
}) => (
  <div data-testid="eclaireur-modal" onClick={onClose} style={{
    position: 'fixed', inset: 0, zIndex: 999, backgroundColor: 'rgba(0,0,0,0.92)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    padding: 20,
  }}>
    <div onClick={e => e.stopPropagation()} style={{
      backgroundColor: '#0a0a0a', borderRadius: 16,
      border: '1px solid rgba(212,175,55,0.2)',
      maxWidth: 640, width: '100%', maxHeight: '85vh', overflow: 'hidden',
      display: 'flex', flexDirection: 'column',
    }}>
      {/* Header */}
      <div style={{
        padding: '24px 24px 16px', borderBottom: '1px solid rgba(212,175,55,0.1)',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      }}>
        <div>
          <p style={{ fontFamily: "'Georgia', serif", fontSize: 18, color: '#D4AF37', fontWeight: 600 }}>
            {eclaireurStep === 'select' ? t('ecl_invite_title') : t('ecl_magic_link')}
          </p>
          <p style={{ fontFamily: "'Georgia', serif", fontSize: 12, color: '#FAF3E0', marginTop: 4 }}>
            {eclaireurStep === 'select'
              ? t('ecl_choose_memories')
              : `${eclaireurSelectedIds.size} ${eclaireurSelectedIds.size > 1 ? t('ecl_memories_shared_plural') : t('ecl_memories_shared')}`
            }
          </p>
        </div>
        <button onClick={onClose} style={{
          background: 'rgba(212,175,55,0.08)', border: '1px solid rgba(212,175,55,0.35)',
          borderRadius: '50%', cursor: 'pointer', color: '#D4AF37', padding: 6,
          width: 36, height: 36, display: 'flex', alignItems: 'center', justifyContent: 'center',
          transition: 'all 0.2s',
        }}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#D4AF37" strokeWidth="2.5" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
        </button>
      </div>

      {eclaireurStep === 'select' ? (
        <>
          {/* Select all */}
          <div style={{ padding: '12px 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <button data-testid="eclaireur-select-all" onClick={() => {
              if (eclaireurSelectedIds.size === photos.length) setEclaireurSelectedIds(new Set());
              else setEclaireurSelectedIds(new Set(photos.map(p => p.id)));
            }} style={{
              fontFamily: "'Georgia', serif", fontSize: 11, color: '#D4AF37',
              background: 'none', border: '1px solid rgba(212,175,55,0.2)',
              borderRadius: 6, padding: '5px 14px', cursor: 'pointer',
            }}>
              {eclaireurSelectedIds.size === photos.length ? 'Tout d\u00e9s\u00e9lectionner' : 'Tout s\u00e9lectionner'}
            </button>
            <span style={{ fontFamily: "'Georgia', serif", fontSize: 12, color: '#D4AF37' }}>
              {eclaireurSelectedIds.size} {eclaireurSelectedIds.size > 1 ? t('ecl_selected_plural') : t('ecl_selected')}
            </span>
          </div>
          {/* Photo grid */}
          <div style={{
            padding: '0 16px 16px', overflowY: 'auto', flex: 1,
            display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)',
            gridAutoRows: 'min-content',
            gap: 6, alignContent: 'start',
          }}>
            {photos.map(photo => {
              const sel = eclaireurSelectedIds.has(photo.id);
              return (
                <div key={photo.id} data-testid={`eclaireur-pick-${photo.id}`}
                  onClick={() => toggleEclaireurPhoto(photo.id)}
                  style={{
                    borderRadius: 8, overflow: 'hidden', cursor: 'pointer',
                    border: sel ? '2px solid #D4AF37' : '1px solid rgba(212,175,55,0.1)',
                    position: 'relative', transition: 'all 0.2s',
                    boxShadow: sel ? '0 0 12px rgba(212,175,55,0.2)' : 'none',
                    aspectRatio: '1 / 1',
                  }}
                >
                  <img
                    src={`${API}/photos/${photo.id}/thumbnail?token=${token}`}
                    alt="" loading="lazy"
                    onLoad={e => { e.target.style.opacity = '1'; }}
                    onError={e => { e.target.style.opacity = '0.3'; e.target.src = '/bobine-face-logo.png'; e.target.style.objectFit = 'contain'; e.target.style.padding = '25%'; }}
                    style={{ width: '100%', height: '100%', objectFit: 'cover', opacity: 0, transition: 'opacity 0.3s', display: 'block' }}
                  />
                  {sel && (
                    <div style={{
                      position: 'absolute', top: 4, right: 4, width: 22, height: 22, borderRadius: 6,
                      background: 'linear-gradient(145deg, #D4AF37, #B8860B)', display: 'flex', alignItems: 'center', justifyContent: 'center',
                    }}>
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#000" strokeWidth="3"><polyline points="20 6 9 17 4 12"/></svg>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
          {/* Message + Generate */}
          <div style={{ padding: '16px 24px', borderTop: '1px solid rgba(212,175,55,0.1)' }}>
            <textarea
              data-testid="eclaireur-message-input"
              placeholder={t('ecl_message_placeholder') || "Un mot pour rassurer votre proche : pourquoi ces souvenirs comptent, ce que vous attendez de lui..."}
              value={eclaireurMessage}
              onChange={e => setEclaireurMessage(e.target.value)}
              maxLength={400}
              rows={3}
              style={{
                width: '100%', fontFamily: "'Georgia', serif", fontSize: 13, color: '#F7E6BD',
                backgroundColor: 'rgba(212,175,55,0.04)', border: '1px solid rgba(212,175,55,0.15)',
                borderRadius: 8, padding: '10px 14px', outline: 'none', marginBottom: 8,
                resize: 'vertical', lineHeight: 1.5, minHeight: 70,
              }}
            />
            <p style={{
              fontFamily: "'Georgia', serif", fontSize: 11, color: 'rgba(247,230,189,0.6)',
              fontStyle: 'italic', margin: '0 0 12px', textAlign: 'right',
            }}>
              {(eclaireurMessage || '').length}/400 — Votre mot personnel apparaîtra dans l'email d'invitation
            </p>
            <button data-testid="eclaireur-generate-btn" onClick={generateEclaireurLink}
              disabled={eclaireurSelectedIds.size === 0 || eclaireurLoading}
              style={{
                width: '100%', fontFamily: "'Georgia', serif", fontSize: 14, fontWeight: 600,
                padding: '12px 20px', borderRadius: 8, cursor: 'pointer',
                backgroundColor: eclaireurSelectedIds.size > 0 ? '#D4AF37' : 'rgba(212,175,55,0.15)',
                color: eclaireurSelectedIds.size > 0 ? '#000' : '#D4AF37',
                border: 'none', transition: 'all 0.3s',
                opacity: eclaireurLoading ? 0.6 : 1,
              }}
            >
              {eclaireurLoading ? t('ecl_generating') : `${t('ecl_generate_link')} (${eclaireurSelectedIds.size})`}
            </button>
          </div>
        </>
      ) : (
        /* Step 2: Link generated */
        <div style={{ padding: '32px 24px', textAlign: 'center' }}>
          <img src="/bobine-face-logo.png" alt="Bobine" style={{
            width: 64, height: 64, objectFit: 'contain', margin: '0 auto 20px', display: 'block',
            filter: 'drop-shadow(0 0 16px rgba(212,175,55,0.4))',
          }} />
          <p style={{ fontFamily: "'Georgia', serif", fontSize: 16, color: '#D4AF37', marginBottom: 8 }}>
            {t('ecl_link_created')}
          </p>
          <p style={{ fontFamily: "'Georgia', serif", fontSize: 12, color: '#FAF3E0', marginBottom: 24, lineHeight: 1.6 }}>
            {t('ecl_link_share_desc')}
          </p>
          <div data-testid="eclaireur-link-display" style={{
            backgroundColor: 'rgba(212,175,55,0.04)',
            border: '1px solid rgba(212,175,55,0.15)',
            borderRadius: 8, padding: '12px 16px', marginBottom: 20,
            fontFamily: "'Georgia', serif", fontSize: 12, color: '#FAF3E0',
            wordBreak: 'break-all', textAlign: 'left',
          }}>
            {eclaireurLink}
          </div>
          <div style={{ display: 'flex', gap: 10, justifyContent: 'center', flexWrap: 'wrap' }}>
            <button data-testid="eclaireur-copy-btn" onClick={copyEclaireurLink}
              style={{
                fontFamily: "'Georgia', serif", fontSize: 13, padding: '11px 22px', borderRadius: 8,
                cursor: 'pointer',
                color: eclaireurLinkCopied ? '#000' : '#D4AF37',
                backgroundColor: eclaireurLinkCopied ? '#D4AF37' : 'transparent',
                border: '1px solid rgba(212,175,55,0.3)', display: 'inline-flex', alignItems: 'center', gap: 8,
                transition: 'all 0.3s',
              }}
            >
              {eclaireurLinkCopied ? (
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="20 6 9 17 4 12"/></svg>
              ) : (
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1"/>
                </svg>
              )}
              {eclaireurLinkCopied ? t('ecl_copied') : t('ecl_copy_link')}
            </button>
            <button data-testid="eclaireur-whatsapp-btn" onClick={shareOnWhatsApp}
              style={{
                fontFamily: "'Georgia', serif", fontSize: 13, padding: '11px 22px', borderRadius: 8,
                cursor: 'pointer', color: '#fff', backgroundColor: '#25D366',
                border: 'none', display: 'inline-flex', alignItems: 'center', gap: 8,
                fontWeight: 600, transition: 'all 0.2s',
              }}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
              </svg>
              {t('ecl_share_whatsapp')}
            </button>
          </div>
          {/* Email invitation section — avec aperçu vignette + édition message */}
          <div style={{ marginTop: 24, borderTop: '1px solid rgba(212,175,55,0.1)', paddingTop: 20 }}>
            <p style={{ fontFamily: "'Georgia', serif", fontSize: 12, color: '#D4AF37', marginBottom: 14, textAlign: 'center', letterSpacing: 1, textTransform: 'uppercase', fontWeight: 600 }}>
              Envoyer par email
            </p>
            {/* CHAMP EMAIL — placé EN HAUT pour visibilité immédiate */}
            <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
              <input
                data-testid="eclaireur-email-input"
                type="email"
                placeholder={t('ecl_email_placeholder') || "Email de votre proche"}
                value={eclaireurEmail || ''}
                onChange={e => setEclaireurEmail(e.target.value)}
                style={{
                  flex: 1, fontFamily: "'Georgia', serif", fontSize: 13, color: '#D4AF37',
                  backgroundColor: 'rgba(212,175,55,0.04)', border: '1px solid rgba(212,175,55,0.15)',
                  borderRadius: 8, padding: '10px 14px', outline: 'none',
                }}
              />
              <button
                data-testid="eclaireur-send-email-btn"
                onClick={sendEclaireurEmail}
                disabled={!eclaireurEmail || eclaireurEmailSending}
                style={{
                  fontFamily: "'Georgia', serif", fontSize: 13, padding: '10px 20px', borderRadius: 8,
                  cursor: eclaireurEmail && !eclaireurEmailSending ? 'pointer' : 'default',
                  backgroundColor: eclaireurEmailSent ? 'rgba(39,174,96,0.15)' : 'rgba(212,175,55,0.08)',
                  color: eclaireurEmailSent ? '#27ae60' : '#D4AF37',
                  border: eclaireurEmailSent ? '1px solid rgba(39,174,96,0.3)' : '1px solid rgba(212,175,55,0.25)',
                  display: 'inline-flex', alignItems: 'center', gap: 6,
                  transition: 'all 0.3s', fontWeight: 600, whiteSpace: 'nowrap',
                  opacity: !eclaireurEmail || eclaireurEmailSending ? 0.5 : 1,
                }}
              >
                {eclaireurEmailSent ? (
                  <>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="20 6 9 17 4 12"/></svg>
                    {t('ecl_email_sent') || 'Envoy\u00e9 !'}
                  </>
                ) : eclaireurEmailSending ? (
                  t('ecl_email_sending') || 'Envoi...'
                ) : (
                  <>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
                    {t('ecl_send_by_email') || 'Envoyer'}
                  </>
                )}
              </button>
            </div>
            {eclaireurEmailSent && (
              <p data-testid="eclaireur-email-success" style={{ fontFamily: "'Georgia', serif", fontSize: 12, color: '#27ae60', marginTop: 4, marginBottom: 12, textAlign: 'center' }}>
                Invitation envoy&eacute;e avec succ&egrave;s !
              </p>
            )}
            {eclaireurEmailError && (
              <p data-testid="eclaireur-email-error" style={{ fontFamily: "'Georgia', serif", fontSize: 12, color: '#c0392b', marginTop: 4, marginBottom: 12, textAlign: 'center' }}>
                {eclaireurEmailError}
              </p>
            )}
            {/* APERÇU — vignette compacte + édition message */}
            {eclaireurLink && (() => {
              // Extraction robuste : dernier segment de l'URL (ignore query)
              const linkId = (eclaireurLink.split('?')[0] || '').split('/').filter(Boolean).pop();
              const firstSelectedId = [...eclaireurSelectedIds][0];
              const thumbUrl = linkId && firstSelectedId
                ? `${API}/eclaireur/view/${linkId}/photo/${firstSelectedId}/thumbnail`
                : null;
              return (
                <div data-testid="eclaireur-email-preview" style={{
                  background: 'rgba(212,175,55,0.04)',
                  border: '1px solid rgba(212,175,55,0.15)',
                  borderRadius: 8, padding: 12, textAlign: 'left',
                }}>
                  <p style={{ fontFamily: "'Georgia', serif", fontSize: 10, color: 'rgba(247,230,189,0.6)', margin: '0 0 8px', textTransform: 'uppercase', letterSpacing: 1 }}>
                    Aperçu de l'email
                  </p>
                  {thumbUrl && (
                    <div style={{ display: 'flex', gap: 10, alignItems: 'flex-start', marginBottom: 10 }}>
                      <img
                        data-testid="eclaireur-thumb-preview"
                        src={thumbUrl}
                        alt="Aperçu"
                        style={{
                          width: 70, height: 70, objectFit: 'cover',
                          borderRadius: 6, border: '1px solid rgba(212,175,55,0.25)',
                          flexShrink: 0,
                        }}
                      />
                      <p style={{ fontFamily: "'Georgia', serif", fontSize: 11, color: 'rgba(247,230,189,0.7)', margin: 0, lineHeight: 1.5, fontStyle: 'italic', flex: 1 }}>
                        Cette vignette + votre message accompagneront l'email envoyé.
                      </p>
                    </div>
                  )}
                  <textarea
                    data-testid="eclaireur-message-edit"
                    value={eclaireurMessage || ''}
                    onChange={e => setEclaireurMessage(e.target.value)}
                    placeholder="Votre mot personnel pour rassurer votre proche..."
                    maxLength={400}
                    rows={2}
                    style={{
                      width: '100%', fontFamily: "'Georgia', serif", fontSize: 12,
                      color: '#F7E6BD', background: 'rgba(0,0,0,0.4)',
                      border: '1px solid rgba(212,175,55,0.18)', borderRadius: 6,
                      padding: '8px 10px', outline: 'none', resize: 'vertical',
                      lineHeight: 1.5, minHeight: 50,
                    }}
                  />
                  <p style={{ fontFamily: "'Georgia', serif", fontSize: 10, color: 'rgba(247,230,189,0.55)', margin: '4px 0 0', textAlign: 'right', fontStyle: 'italic' }}>
                    {(eclaireurMessage || '').length}/400 — modifiable avant l'envoi
                  </p>
                </div>
              );
            })()}
          </div>
        </div>
      )}
    </div>
  </div>
);

export default EclaireurModal;
